export default __webpack_public_path__ + "static/media/depNumberIcon.c3b22883.svg";